import styled from 'styled-components';

export const SelectWrapper = styled.div`
  .form-group {
    margin-bottom: 0;
  }

  .form-control {
    height: 40px;
    min-height: 40px;
    padding: 0 42px 0 14px !important;
    border-radius: 8px;
    background-color: #f7f7f7;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%2392929D' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 14px center;
    background-size: 18px 18px;
    border: 1px solid #f7f7f7;
    color: #696974;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    option {
      padding: 5px 0 !important;
      height: 40px !important;
      color: #44444f;
    }

    &:focus {
      box-shadow: none;
      border-color: #f7f7f7;
    }
  }

  .input-group-merge {
    .input-group-prepend .input-group-text {
      height: 40px;
      min-width: 48px;
      justify-content: center;
      border: 1px solid #d8d6de;
      border-right: 0;
      border-radius: 8px 0 0 8px;
      background-color: #ffffff;
    }

    .form-control {
      border: 1px solid #d8d6de;
      border-left: 0;
      border-radius: 0 8px 8px 0;
    }

    .form-control:focus,
    &:focus-within .input-group-text {
      border-color: #7367f0;
    }

    .form-control:disabled,
    .form-control:disabled ~ .input-group-append .input-group-text,
    .bg-disabled {
      background-color: #efefef;
    }
  }
`;
